// src/helpers/reports/getReportIdKey.ts
var getReportIdKey = (bucket) => {
  switch (bucket) {
    case "customReports":
      return "customReportId";
    case "itemComboSalesReports":
      return "itemComboSalesReportId";
    case "salesOverviewReports":
      return "salesOverviewReportId";
    case "creditCardBatchReports":
      return "creditCardBatchReportId";
    case "employeeSalesAndTipsReports":
      return "employeeSalesAndTipsReportId";
    case "endOfShiftReports":
      return "endOfShiftReportId";
    case "voidReasonsReports":
      return "voidReasonsReportId";
    case "inventoryOnHandReports":
      return "inventoryOnHandReportId";
    case "creditBalancesReports":
      return "creditBalancesReportId";
  }
};

export { getReportIdKey };
